import appConfig from '../../config';
import { eventSourceStore } from './EventsModule.svelte';
const RECONNECTION_ATTEMPT_MAX = 100;
class EventsService {
    userId;
    reconnectionAttempts = 0;
    eventSource = null;
    eventSourceOther = null; // Secondary event source for now we will be using this to avoid major refactors
    subscribers = [];
    onReconnectCallback = null;
    onErrorCallback = null;
    didError = false;
    onReconnect(callback) {
        this.onReconnectCallback = callback;
    }
    onError(callback) {
        this.onErrorCallback = callback;
    }
    setupEventSource(eventSource, userId, debug = false) {
        if (debug)
            console.log('Setting up event source', eventSource);
        eventSourceStore.set({
            connected: false,
            error: false,
            connecting: true
        });
        eventSource.onopen = () => {
            if (debug)
                console.log('Connection opened', eventSource);
            if (this.didError) {
                console.warn('Calling onReconnect callback');
                if (this.onReconnectCallback)
                    this.onReconnectCallback();
            }
            this.didError = false;
            eventSourceStore.set({
                connected: true,
                error: false,
                connecting: false
            });
            this.reconnectionAttempts = 0;
        };
        eventSource.onmessage = event => {
            const message = JSON.parse(event.data);
            this.subscribers.forEach(subscriber => {
                if (subscriber.event && message.event != subscriber.event)
                    return false;
                subscriber.callback(message);
            });
        };
        eventSource.onerror = error => {
            console.error('[EventSource Error]', error);
            this.didError = true;
            if (this.onErrorCallback)
                this.onErrorCallback(error);
            eventSourceStore.set({
                connected: false,
                connecting: false,
                error: true
            });
            // eventSource.close();
            // setTimeout(() => {
            //   console.warn('[Eventsource Reconnection Attempt]');
            //   this.setupEventSource(eventSource, userId, debug);
            // }, 2000);
        };
    }
    subscribe(userId) {
        this.userId = userId;
        // this.eventSource = new EventSource(baseURL + '/events/subscribe/' + userId);
        this.eventSourceOther = new EventSource(appConfig.eventsUrl + '/subscribe/' + userId);
        // this.setupEventSource(this.eventSource, userId);
        this.setupEventSource(this.eventSourceOther, userId, !appConfig.isProd);
    }
    reconnect(eventSource, userId) {
        console.warn('[EventSource] Triggering Reconnect Logic');
        if (!(eventSource instanceof EventSource))
            return console.log('EventService: eventSource is invalid', { eventSource });
        if (this.reconnectionAttempts > RECONNECTION_ATTEMPT_MAX)
            return console.log('EventService: Reached maimum reconnection attempts.');
        this.reconnectionAttempts++;
        console.warn('Attempting reconnection', this.reconnectionAttempts);
        eventSource.close();
        try {
            this.subscribe(userId);
        }
        catch (err) {
            setTimeout(() => this.reconnect(eventSource, userId), 1000);
        }
    }
    on(event, callback) {
        // console.log("ON", { callback });
        this.subscribers.push({ event, callback });
        return () => this.off(event, callback);
    }
    off(event, callback) {
        // console.log("OFF", { callback });
        this.subscribers = this.subscribers.filter(subscriber => {
            return subscriber.event != event && subscriber.callback != callback;
        });
    }
    clear(events) {
        if (!Array.isArray(events))
            events = [events];
        this.subscribers = this.subscribers.filter(subscriber => {
            return !events.includes(subscriber.event);
        });
    }
    events() {
        return this.subscribers;
    }
    trigger(event, data) {
        this.subscribers.filter(subscriber => subscriber.event == event).forEach(subscriber => subscriber.callback(data));
    }
}
const appEvents = new EventsService();
export default appEvents;
